import { render, staticRenderFns } from "./HomePageClientsSection.vue?vue&type=template&id=0eb8bcbd&scoped=true&"
import script from "./HomePageClientsSection.vue?vue&type=script&lang=js&"
export * from "./HomePageClientsSection.vue?vue&type=script&lang=js&"
import style0 from "./HomePageClientsSection.vue?vue&type=style&index=0&id=0eb8bcbd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb8bcbd",
  null
  
)

export default component.exports